import axios from 'axios';

// NoCodeBackend API configuration
const API_BASE_URL = import.meta.env.VITE_NOCODEBACKEND_URL || 'https://openapi.nocodebackend.com';
const API_KEY = import.meta.env.VITE_NOCODEBACKEND_KEY || '';
const INSTANCE_ID = import.meta.env.VITE_NOCODEBACKEND_INSTANCE || '54230_nocodebackend';

// Validate required environment variables
if (!API_KEY) {
  console.warn('NoCodeBackend API key is not configured. Please set VITE_NOCODEBACKEND_KEY environment variable.');
}

const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
  timeout: 15000, // Increased timeout to 15 seconds
});

// Request interceptor for auth token and instance parameter
api.interceptors.request.use(
  (config) => {
    // Add Authorization header with API key
    if (API_KEY) {
      config.headers.Authorization = `Bearer ${API_KEY}`;
    }
    
    // Add Instance parameter to all requests
    const separator = config.url.includes('?') ? '&' : '?';
    config.url = `${config.url}${separator}Instance=${INSTANCE_ID}`;
    
    console.log(`API Request: ${config.method?.toUpperCase()} ${config.url}`, {
      headers: config.headers,
      data: config.data
    });
    
    return config;
  },
  (error) => {
    console.error('Request interceptor error:', error);
    return Promise.reject(error);
  }
);

// Response interceptor for error handling
api.interceptors.response.use(
  (response) => {
    console.log(`API Response: ${response.config.method?.toUpperCase()} ${response.config.url}`, {
      status: response.status,
      data: response.data
    });
    return response;
  },
  (error) => {
    console.error('API Error:', {
      message: error.message,
      status: error.response?.status,
      statusText: error.response?.statusText,
      data: error.response?.data,
      config: {
        method: error.config?.method?.toUpperCase(),
        url: error.config?.url,
        params: error.config?.params
      }
    });
    
    if (error.response?.status === 401) {
      localStorage.removeItem('auth-token');
      localStorage.removeItem('user-data');
      window.location.href = '/#/login';
    }
    
    return Promise.reject(error);
  }
);

export default api;